import { Injectable } from '@angular/core';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { Actions, Effect, ofType } from '@ngrx/effects';

import * as easelActions from './easel.actions';
import * as rootActions from '../../../state/app.actions';
import * as fromRoot from '../../../state/app.reducer';

import { EaselService } from '../easel.service';

import { Easel } from '../../../_models/easel';
import { EaselType } from '../../../_models/easel_type';
import { EaselFamily } from '../../../_models/easel_family';
import { Product } from '../../../_models/product';

@Injectable()
export class EaselEffects {

    @Effect()
    loadEasel$ = this.actions$.pipe(
        ofType(easelActions.EaselActitonTypes.LoadEasels),
        mergeMap((action: easelActions.LoadEasels) => {
                this.changingLoading(true);
                // console.log('-->... Payload LoadEasels =');
                // console.log(action.payload);
                return this.easelService.getEasels(action.payload).pipe(
                    map((easels: Easel[]) => {
                        this.changingLoading(false);
                        return new easelActions.LoadEaselsSuccess(easels);
                    }),
                    catchError(err => of(new easelActions.LoadEaselsFail(err)))
                );
            }
        )
    );

    @Effect()
    updateEasel$ = this.actions$.pipe(
        ofType(easelActions.EaselActitonTypes.UpdateEasel),
        mergeMap((action: easelActions.UpdateEasel) => {
                this.changingLoading(true);
                // console.log('-->... Payload UpdateEasel =');
                // console.log(action.payload);

                return this.easelService.updateEasel(action.payload).pipe(
                    map((easel: Easel) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server UpdateEasel =');
                        console.log(easel);
                        if (easel !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/easel', null, 'info');
                            return new easelActions.UpdateEaselSuccess(easel);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new easelActions.UpdateEaselFail('ERROR UpdateEasel effect.');
                        }
                    }),
                    catchError(err => of(new easelActions.UpdateEaselFail(err)))
                );
            }
        )
    );

    @Effect()
    CreateEasel$ = this.actions$.pipe(
        ofType(easelActions.EaselActitonTypes.CreateEasel),
        mergeMap((action: easelActions.CreateEasel) => {
                this.changingLoading(true);
                // console.log('-->... Payload CreateEasel =');
                // console.log(action.payload);

                return this.easelService.createEasel(action.payload).pipe(
                    map((easel: Easel) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server CreateEasel =');
                        // console.log(easel);
                        if (easel !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/easel', null, 'info');
                            return new easelActions.CreateEaselSuccess(easel);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new easelActions.CreateEaselFail('ERROR CreateEasel effect.');
                        }
                    }),
                    catchError(err => of(new easelActions.CreateEaselFail(err)))
                );
            }
        )
    );

    @Effect()
    deleteEasel$ = this.actions$.pipe(
        ofType(easelActions.EaselActitonTypes.DeleteEasel),
        mergeMap((action: easelActions.DeleteEasel) => {
                this.changingLoading(true);
                // console.log('-->... Payload DeleteEasel =');
                // console.log(action.payload);

                return this.easelService.deleteEasel(action.payload).pipe(
                    map((easelId: bigint) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server DeleteEasel =');
                        console.log(easelId);
                        if (easelId !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '', null, 'info');
                            return new easelActions.DeleteEaselSuccess(easelId);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new easelActions.DeleteEaselFail('ERROR DeleteEasel effect.');
                        }
                    }),
                    catchError(err => of(new easelActions.DeleteEaselFail(err)))
                );
            }
        )
    );


    // Easel type
  @Effect()
  loadAllTypes$ = this.actions$.pipe(
    ofType(easelActions.EaselActitonTypes.LoadAllTypes),
    mergeMap((action: easelActions.LoadAllTypes) => {
        this.changingLoading(true);
        return this.easelService.getTypes().pipe(
          map((types: EaselType[]) => {
            this.changingLoading(false);
            return new easelActions.LoadAllTypesSuccess(types);
          }),
          catchError(err => of(new easelActions.LoadAllTypesFail(err)))
        );
      }
    )
  );

  // Easel family
  @Effect()
  loadFamilies$ = this.actions$.pipe(
    ofType(easelActions.EaselActitonTypes.LoadFamilies),
    mergeMap((action: easelActions.LoadFamilies) => {
        this.changingLoading(true);
        return this.easelService.getFamilies().pipe(
          map((families: EaselFamily[]) => {
            this.changingLoading(false);
            return new easelActions.LoadFamiliesSuccess(families);
          }),
          catchError(err => of(new easelActions.LoadFamiliesFail(err)))
        );
      }
    )
  );

  // Freights

  @Effect()
  LoadFreights$ = this.actions$.pipe(
    ofType(easelActions.EaselActitonTypes.LoadFreights),
    mergeMap((action: easelActions.LoadFreights) => {
        this.changingLoading(true);
        return this.easelService.getFreights(action.payload).pipe(
          map((freights: Product[]) => {
            this.changingLoading(false);
            return new easelActions.LoadFreightsSuccess(freights);
          }),
          catchError(err => of(new easelActions.LoadFreightsFail(err)))
        );
      }
    )
  );

    // -----------------------------

    constructor(private actions$: Actions,
                private easelService: EaselService,
                private storeRoot: Store<fromRoot.State>) {

    }

    changingLoading(value: boolean) {
        console.log('---->>>>.... Ejecutando changingLoading: ' + value);
        this.storeRoot.dispatch( new rootActions.ChangeLoading(value));
    }

    showInfoModal(value: boolean, info: string, link: string, param: null, skin: string) {
        console.log('---->>>>.... Ejecutando Easel Effect showInfoModal: ' + value + ' ;Param: ' + param + ' ;Info: ' + info);
        this.storeRoot.dispatch( new rootActions.ChangeInfoModal({value, info, link, param, skin }));
    }
}
